import { useEffect } from "react";
import { usePlayer } from "./usePlayer";

// hook up MediaSession + hardware media keys.
export function usePlaybackSync() {
  const p = usePlayer();
  useEffect(() => {
    if (!("mediaSession" in navigator)) return;
    navigator.mediaSession.setActionHandler?.("play", () => p.toggle());
    navigator.mediaSession.setActionHandler?.("pause", () => p.toggle());
    navigator.mediaSession.setActionHandler?.("nexttrack", () => p.next());
    navigator.mediaSession.setActionHandler?.("previoustrack", () => p.prev());
  }, [p]);
}
